import { memo } from "react"
import { useSelector } from "react-redux"
import { LoadPanel } from "devextreme-react"
import { powerBISelector } from "redux/powerBI/powerBISlice"

const PowerBILoader = () => {
  const { loading } = useSelector(powerBISelector)

  return (
    <LoadPanel
      shadingColor="rgba(0,0,0,0.4)"
      position="center"
      visible={loading === "LOADING"}
      showIndicator
      shading
      showPane
    />
  )
}

export default memo(PowerBILoader)
